module.exports = __webpack_public_path__ + "img/test_image1.fb7958ad.jpg";